import _ from 'lodash';
import React from 'react';
import { getGrowthBookFeatureFlag } from 'src/featureFlags';
import { Keys, locale } from 'src/i18n';
import {
  getCurrentUser,
  getDashboardSections,
  getFeaturesConfig,
} from 'src/models/lmsConfig/queries';
import { getSecureRandomNumber } from './queries';

function WelcomeCard() {
  const randomInt = Math.floor(getSecureRandomNumber() * 3) + 1;

  const userName = getCurrentUser().name;

  const isSuperSetEnable = _.get(getFeaturesConfig, 'superset_enabled', false);
  const dashboardSections = getDashboardSections();

  const supersetDashboardSection = _.find(dashboardSections, {
    type: 'superset-dashboard',
    display: true,
  });

  const isReportModuleEnabled = () => {
    const activeSections =
      getDashboardSections()?.filter((section) => section.display !== false) ??
      [];

    return activeSections.some((section) =>
      _.includes(section.modules, 'reports'),
    );
  };

  const isSupersetEnabled =
    _.includes(supersetDashboardSection?.modules, 'superset-dashboard') &&
    isSuperSetEnable;

  const isNewCommunicationBannerAllowed =
    getGrowthBookFeatureFlag('allow-new-communication-banner') &&
    isSupersetEnabled;

  const renderText = () => {
    if (!isReportModuleEnabled() || randomInt === 1) {
      return <span>{locale(Keys.WELCOME_TEXT1)}</span>;
    }

    if (isNewCommunicationBannerAllowed) {
      return (
        <span>
          {locale(Keys.WELCOME_TEXT3_NEW_A)}{' '}
          <a href="#/web2/dashboards">{locale(Keys.CLICK_LINK)}</a>{' '}
          {locale(Keys.WELCOME_TEXT3_NEW_B)}
        </span>
      );
    }

    return (
      <span>
        {locale(Keys.WELCOME_TEXT3_NEW_B)}{' '}
        <a href="#/web2/reports/all">{locale(Keys.CLICK_LINK)}</a>{' '}
        {locale(Keys.WELCOME_TEXT3_B)}
      </span>
    );
  };

  return (
    <div className="welcome-card">
      <p className="title">
        {`${locale(Keys.HEY_STRING)} ${userName}`}
        {locale(Keys.HEY_TEXT)}
        <span role="img" aria-label="Welcome" className="nba-hello-icon">
          {locale(Keys.HEY)},
        </span>
        <span className="subtitle">{renderText()}</span>
      </p>
    </div>
  );
}

export default WelcomeCard;
